module.exports = __webpack_public_path__ + "img/user-m-grey.fe559b3.svg";